import _ from 'lodash'
import { CarouselButtonSchema, MessageStepSchema } from '@feedyou/schema'
import { nanoid } from 'nanoid/non-secure'

import { sanitizeText, sanitizeTextArray } from '../../../lib/sanitizeText'

export const actionTypes = {
  SET_MESSAGE: 'SET_MESSAGE',
  ADD_CAROUSEL_ITEM: 'ADD_CAROUSEL_ITEM',
  REMOVE_CAROUSEL_ITEM: 'REMOVE_CAROUSEL_ITEM',
  EDIT_PROPERTY: 'EDIT_PROPERTY',
  ADD_ITEM_BUTTON: 'ADD_ITEM_BUTTON',
  EDIT_ITEM_BUTTON: 'EDIT_ITEM_BUTTON',
  MOVE_CAROUSEL_ITEM: 'MOVE_CAROUSEL_ITEM',
  UNSET_IS_NEW: 'UNSET_IS_NEW'
} as const

export function setMessage(message: string) {
  return {
    type: actionTypes.SET_MESSAGE,
    payload: sanitizeText(message)!
  }
}

export function addCarouselItem() {
  return {
    type: actionTypes.ADD_CAROUSEL_ITEM,
    payload: { id: nanoid(9) }
  }
}

export function removeCarouselItem(itemIndex: number) {
  return {
    type: actionTypes.REMOVE_CAROUSEL_ITEM,
    payload: itemIndex
  }
}

export function editProperty<PropName extends keyof MessageStepSchema & string>(
  itemIndex: number,
  type: PropName,
  value?: MessageStepSchema[PropName]
) {
  const valueCopy = _.cloneDeep(value)
  const sanitizedValue = _.isArray(valueCopy)
    ? sanitizeTextArray(valueCopy)
    : sanitizeText(valueCopy)

  return {
    type: actionTypes.EDIT_PROPERTY,
    payload: { itemIndex, type, value: sanitizedValue }
  }
}

export function addItemButton(itemIndex: number, properties: CarouselButtonSchema) {
  return {
    type: actionTypes.ADD_ITEM_BUTTON,
    payload: { itemIndex, properties: { id: nanoid(9), ...properties } }
  }
}

export function editItemButton(
  itemIndex: number,
  buttonIndex: number,
  properties: CarouselButtonSchema
) {
  return {
    type: actionTypes.EDIT_ITEM_BUTTON,
    payload: { itemIndex, buttonIndex, properties }
  }
}

export function moveCarouselItem(srcIndex: number, destIndex: number) {
  return {
    type: actionTypes.MOVE_CAROUSEL_ITEM,
    payload: { srcIndex, destIndex }
  }
}

export type Action =
  | ReturnType<typeof setMessage>
  | ReturnType<typeof addCarouselItem>
  | ReturnType<typeof removeCarouselItem>
  | ReturnType<typeof editProperty>
  | ReturnType<typeof addItemButton>
  | ReturnType<typeof editItemButton>
  | ReturnType<typeof moveCarouselItem>
